import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "max", "min", "disabled"]

import {useId} from "vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'number',
  props: /*@__PURE__*/_mergeModels({
    max: {
      default: null,
      required: false,
      type: Number
    },
    min: {
      default: null,
      required: false,
      type: Number
    },
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    },
    title: {
      default: null,
      required: false,
      type: String
    }
  }, {
    "value": {
    default: null,
    required: true,
    type: Number
  },
    "valueModifiers": {},
  }),
  emits: ["update:value"],
  setup(__props) {

  const props = __props
  const id = useId()
  const value = _useModel(__props, "value")

  function validate() {
    if (props.min && value.value < props.min) {
      value.value = props.min
    }
    if (props.max && value.value > props.max) {
      value.value = props.max
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      (__props.title)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: _unref(id)
          }, _toDisplayString(__props.title), 9, _hoisted_1))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", {
        id: _unref(id),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        max: __props.max,
        min: __props.min,
        type: "number",
        disabled: __props.readOnly,
        onChange: _cache[1] || (_cache[1] = ($event: any) => (validate()))
      }, null, 40, _hoisted_2), [
        [_vModelText, value.value]
      ])
    ]),
    _: 1
  }))
}
}

})